export default __webpack_public_path__ + "static/media/body.7ac8680a.svg";